import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../aws/AuthContext'; // Asegúrate de que la ruta sea correcta

const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = `${API_BASE_URL}/v1-productos`;

// Hook para OBTENER todos los productos
export const useGetProductos = (verEliminados = false) => {
  const { getJwtToken } = useAuth();

  return useQuery({
    queryKey: ['productos', verEliminados], // El queryKey cambia según el filtro
    queryFn: async () => {
      const token = await getJwtToken();
      const url = verEliminados ? `${API_URL}?papelera=true` : API_URL;
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!res.ok) throw new Error('Error al cargar productos');
      const datos = await res.json();

      return datos;
    },
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
  });
};

// Hook para GUARDAR (Crear o Editar)
export const useSaveProducto = () => {

  const queryClient = useQueryClient();
  const { getJwtToken } = useAuth();

  return useMutation({
    mutationFn: async (payload) => {
      const token = await getJwtToken();

      // Si el payload tiene ID, es PUT (editar), si no, es POST (crear)
      const esEdicion = !!payload.id;
      const url = esEdicion ? `${API_URL}/${payload.id}` : API_URL;

      const res = await fetch(url, {
        method: esEdicion ? "PUT" : "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error('Error al procesar el producto');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productos'] });
      queryClient.invalidateQueries({ queryKey: ['stock_bodega'] });
      queryClient.invalidateQueries({ queryKey: ['bodegas'] });
    },
  });
};

// Hook exclusivo para ELIMINAR (Soft Delete)
export const useDeleteProducto = () => {
  const queryClient = useQueryClient();
  const { getJwtToken } = useAuth();

  return useMutation({
    mutationFn: async (id) => {
      const token = await getJwtToken();

      const res = await fetch(`${API_URL}/${id}`, {
        method: "DELETE", // Petición HTTP DELETE directa
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      if (!res.ok) throw new Error('Error al eliminar el producto');
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productos'] });
      queryClient.invalidateQueries({ queryKey: ['stock_bodega'] });
      queryClient.invalidateQueries({ queryKey: ['bodegas'] });
    },
  });
};